import React from "react";
import css from "./PageHeader.module.css";
import classNames from "classnames";

export const PageHeader = ({ title, subtitle, children = null, extraClass = null }) => {
  return (
    <div className={classNames(css.headerContainer, extraClass)}>
      <h1 className={css.title}>{title}<span className={css.headerActions}>{children}</span></h1>
      <h2>{subtitle}</h2>
    </div>
  );
};
